import { Navigate, useLocation } from 'react-router';

import { useSession } from '../session';
import { loginRedirectState } from './loginRedirect';
import { PATHS } from './paths';

/**
 * No session, no screen.
 *
 * `replace` matters: without it, pressing Back after signing in returns to the
 * login screen, which redirects forward again, and the person is stuck bouncing
 * between the two.
 *
 * This is convenience, not security. The server refuses an unauthenticated
 * request whatever the browser decides to render -- every route under
 * `/api/v1` except health and the token endpoints carries the authentication
 * dependency, so there is nothing behind this guard that is protected *by* it.
 */
export function RequireSession({ children }: { children: React.ReactNode }) {
  const session = useSession();
  const location = useLocation();

  if (session === null) {
    return <Navigate to={PATHS.login} replace state={loginRedirectState(location)} />;
  }

  return <>{children}</>;
}
